"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invokeapi = void 0;
async function invokeapi(endpoint, options = {}) {
    const { method = "POST", body, env = "prod", runtime = "edge" } = options;
    const initOptions = {
        method,
        headers: {
            "Content-Type": "application/json",
        },
        signal: options.signal,
    };
    // Only include body for methods that typically have a request body
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase()) && body) {
        initOptions.body = JSON.stringify(body);
    }
    if (endpoint.startsWith("/")) {
        throw new Error("`endpoint` must not begin with a slash");
    }
    let baseUrl = options.prefixUrl;
    if (!baseUrl) {
        if (runtime === "edge") {
            switch (env) {
                case "prod":
                    baseUrl = "https://api.golfb2b.com/api";
                    break;
                case "staging":
                    baseUrl = "https://api-staging.golfb2b.com/api";
                    break;
                default:
                    baseUrl = "http://localhost:3000/api";
                    break;
            }
        }
        else {
            switch (env) {
                case "prod":
                    baseUrl = "https://nodeapi.golfb2b.com/api";
                    break;
                case "staging":
                    baseUrl = "https://nodeapi-staging.golfb2b.com/api";
                    break;
                default:
                    baseUrl = "http://localhost:3000/api";
                    break;
            }
        }
    }
    if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
    }
    const response = await fetch(`${baseUrl}${endpoint}`, initOptions);
    if (!response.ok) {
        return {
            body: response.statusText,
            status: response.status,
            success: false,
        };
    }
    return {
        body: await response.json(),
        status: response.status,
        success: true,
    };
}
exports.invokeapi = invokeapi;
